import React from 'react';

import { Svg, type SvgProps } from './svg';

export function DuplicateIcon(props: SvgProps) {
  return (
    <Svg data-testid="duplicate-icon" {...props}>
      <path d="M18 11h-3v3h-2v-3h-3V9h3V6h2v3h3v2Zm2-7v12H8V4h12Zm0-2H8a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6Z" />
    </Svg>
  );
}
